import React, { useCallback, useState } from 'react'
import { Card } from '@chilecompra/react-kit/components'
import { REACT_APP_MP_URL } from '../../config/settings/environment'
import AboutSiteNavButton from '../../components/Navigation/AboutSiteNavButton'
import {
  CardCollapse,
  CardCollapseIcon,
  CardDescription,
  CardItem,
  CardList,
  CardTitle,
  Description,
  GridContainer,
  GridItem,
  Link,
  Root,
  Title
} from './AboutSiteGoalSection.styles'

/**
 * The AboutSiteGoalSection's container.
 */
const AboutSiteGoalSection = () => {
  const [openExcludedCard, setOpenExcludedCard] = useState(false)
  const [openTradeCard, setOpenTradeCard] = useState(false)
  const [openTradedMattersCard, setOpenTradedMattersCard] = useState(false)
  const handleOpenExcludedCard = useCallback(() => setOpenExcludedCard(currentValue => !currentValue))
  const handleOpenTradeCard = useCallback(() => setOpenTradeCard(currentValue => !currentValue))
  const handleOpenTradedMattersCard = useCallback(() => setOpenTradedMattersCard(currentValue => !currentValue))

  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <AboutSiteNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Objetivo del sitio</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 26px">
        <GridItem xs={12}>
          <Description>
            Este sitio de ChileCompra entrega datos de las compras públicas realizadas a través de la plataforma{' '}
            <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
              www.mercadopublico.cl
            </Link>{' '}
            para facilitar su análisis, monitoreo, fiscalización, desarrollo de nuevas aplicaciones u otros fines
            pertinentes.
            <br />
            <br />
            Los montos se basan en órdenes de compra emitidas por los organismos que transan en{' '}
            <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
              www.mercadopublico.cl
            </Link>
            . Es importante señalar que estos corresponden a compromisos de compra y no a pagos a proveedores.
            <br />
            <br />
            El sitio está orientado principalmente a apoyar la labor de compras de las instituciones del sector público,
            así como brindar información a la ciudadanía, los centros de estudios y organismos fiscalizadores, entre
            otros. Ello con el objetivo de potenciar no sólo el valor de la información de las compras públicas, sino
            también ofrecer una mayor cantidad de datos en formatos definidos y complementarlos con otros datos
            existentes sobre el Estado.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer spacing={1}>
              <GridItem xs={11}>
                <CardTitle>
                  ¿Quiénes transan en{' '}
                  <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
                    Mercado Público
                  </Link>
                  ?
                </CardTitle>
              </GridItem>
              <GridItem align="right" xs={1}>
                <CardCollapseIcon open={openTradeCard} onClick={handleOpenTradeCard} />
              </GridItem>
            </GridContainer>
            <CardCollapse unmountOnExit in={openTradeCard} timeout="auto">
              <GridContainer padding="32px 0 24px">
                <GridItem xs={12}>
                  <CardDescription>
                    Transan en Mercado Público los organismos del Estado regidos por la ley N° 19.886 y su reglamento,
                    esto es, entre otros:
                  </CardDescription>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <CardList>
                    <CardItem>Ministerios</CardItem>
                    <CardItem>
                      Órganos y servicios públicos creados para el cumplimiento de la función administrativa
                    </CardItem>
                    <CardItem>Hospitales públicos</CardItem>
                    <CardItem>Intendencias</CardItem>
                    <CardItem>Gobernaciones</CardItem>
                    <CardItem>Gobiernos Regionales</CardItem>
                    <CardItem>Municipalidades</CardItem>
                    <CardItem>FF.AA., de Orden y Seguridad Pública</CardItem>
                    <CardItem>Universidades estatales</CardItem>
                    <CardItem>Contraloría General de la República</CardItem>
                    <CardItem>
                      Consejo Nacional de Televisión (se incorpora a partir de abril de 2018 de acuerdo a ley N° 21.005)
                    </CardItem>
                  </CardList>
                </GridItem>
              </GridContainer>
            </CardCollapse>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer spacing={1}>
              <GridItem xs={11}>
                <CardTitle>
                  ¿Quiénes están excluidos de{' '}
                  <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
                    Mercado Público
                  </Link>
                  ?
                </CardTitle>
              </GridItem>
              <GridItem align="right" xs={1}>
                <CardCollapseIcon open={openExcludedCard} onClick={handleOpenExcludedCard} />
              </GridItem>
            </GridContainer>
            <CardCollapse unmountOnExit in={openExcludedCard} timeout="auto">
              <GridContainer padding="32px 0 24px">
                <GridItem xs={12}>
                  <CardDescription>
                    Los órganos que están excluidos de la aplicación de la ley son los siguientes, entre otros:
                  </CardDescription>
                </GridItem>
              </GridContainer>
              <GridContainer padding="0 0 32px">
                <GridItem xs={12}>
                  <CardList>
                    <CardItem>Empresas Públicas creadas por ley</CardItem>
                    <CardItem>Ministerio Público</CardItem>
                    <CardItem>Banco Central</CardItem>
                    <CardItem>Corporación Administrativa del Poder Judicial</CardItem>
                    <CardItem>Tribunales especiales de la República</CardItem>
                    <CardItem>Tribunal Constitucional</CardItem>
                    <CardItem>
                      Justicia Electoral compuesta por el Tribunal Calificador de Elecciones y los tribunales
                      electorales regionales
                    </CardItem>
                    <CardItem>
                      Congreso Nacional (sin embargo luego de firma de protocolo con Ministerio de Hacienda a fines de
                      2017 se acuerda su incorporación voluntaria a ChileCompra)
                    </CardItem>
                  </CardList>
                </GridItem>
              </GridContainer>
              <GridContainer padding="0 0 24px">
                <GridItem xs={12}>
                  <CardDescription>
                    No obstante lo anterior existen órganos que, no estando obligados, han accedido voluntariamente a
                    ChileCompra gracias a la atribución que se ha venido incorporando como glosa en la ley de
                    Presupuestos del Sector Público, desde el año 2007 en la partida de ChileCompra.
                    <br />
                    <br />
                    Entre éstos cabe mencionar:
                  </CardDescription>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <CardList>
                    <CardItem>Cámara de Diputados</CardItem>
                    <CardItem>Senado</CardItem>
                    <CardItem>Consejo Resolutivo de Asignaciones Parlamentaria</CardItem>
                    <CardItem>Corporación Administrativa del Poder Judicial</CardItem>
                    <CardItem>Empresa de Abastecimiento de Zonas Aisladas-Emaza</CardItem>
                    <CardItem>Empresa Portuaria Antofagasta</CardItem>
                    <CardItem>Empresa Portuaria Iquique</CardItem>
                    <CardItem>Fundación de La Familia</CardItem>
                    <CardItem>Fundación de Orquestas Juveniles e Infantiles de Chile</CardItem>
                    <CardItem>Fundación Prodemu</CardItem>
                    <CardItem>Metro S.A.</CardItem>
                  </CardList>
                </GridItem>
              </GridContainer>
            </CardCollapse>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer spacing={1}>
              <GridItem xs={11}>
                <CardTitle>
                  ¿Qué materias se transan en{' '}
                  <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
                    Mercado Público
                  </Link>
                  ?
                </CardTitle>
              </GridItem>
              <GridItem align="right" xs={1}>
                <CardCollapseIcon open={openTradedMattersCard} onClick={handleOpenTradedMattersCard} />
              </GridItem>
            </GridContainer>
            <CardCollapse unmountOnExit in={openTradedMattersCard} timeout="auto">
              <GridContainer padding="32px 0 24px">
                <GridItem xs={12}>
                  <CardDescription>
                    En Mercado Público se realizan las compras y contrataciones asociadas a contratos para el suministro
                    de bienes muebles y los servicios que se requieran para el desarrollo de las funciones de la
                    Administración del Estado. Asimismo, desde la entrada en vigencia de la ley N° 20.355, también se
                    realizan las concesiones de servicios municipales.
                    <br />
                    <br />
                    Los siguientes contratos están excluidos de la aplicación de la ley, entre otros:
                  </CardDescription>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <CardList>
                    <CardItem>
                      Contratación de personal de la Administración del Estado y los contratos a honorarios que se
                      celebren con personas naturales para prestar servicios a organismos públicos
                    </CardItem>
                    <CardItem>
                      Ejecución de obra pública y concesión de obra pública (no obstante a partir del 2017 el Ministerio
                      de Obras Públicas se encuentra transando paulatinamente sus obras públicas en Mercado Público de
                      forma voluntaria a través de glosa en la ley de Presupuestos del Sector Público 2017); salvo los
                      contratos de obra pública celebrados directamente por un organismo público que no hayan sido
                      encargados al MOP o no tengan normas específicas relativas a la forma de contratación de obras
                      públicas
                    </CardItem>
                    <CardItem>Obras urbanas con participación de terceros</CardItem>
                    <CardItem>Contratos sobre material de guerra</CardItem>
                    <CardItem>Contratos que se celebren en virtud de las leyes 7.144 y 13.196</CardItem>
                    <CardItem>
                      Adquisición por parte de las Fuerzas Armadas o por las Fuerzas de Orden y Seguridad Pública: de
                      vehículos de uso militar o policial; equipos y sistemas de información de tecnología avanzada y
                      emergente, para sistemas de comando.
                    </CardItem>
                  </CardList>
                </GridItem>
              </GridContainer>
            </CardCollapse>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card color="primary">
            <GridContainer>
              <GridItem xs={12}>
                <CardDescription>
                  Se deja constancia que la Dirección ChileCompra no asume responsabilidad alguna, ni otorga respecto de
                  la información, garantía de ningún tipo por el uso o aplicación que se haga de ésta, especialmente en
                  lo que se refiere a su exactitud, vigencia o integridad.
                </CardDescription>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default AboutSiteGoalSection
